import { InAppNotification } from '@mobi/api-types/inAppMarketing'
import { get, put } from '@core/Services/ApiService'

const API_BASE = '/api/v2/marketing-automation/v1/in-app-notifications'

export function getInAppMarketingActiveNotifications() {
  return get<InAppNotification[]>({
    url: `${API_BASE}?status=Active`,
  })
}

export function dismissNotification(notificationId: string) {
  return put({
    url: `${API_BASE}/${notificationId}/dismiss`,
  })
}

export function recordNotificationInteraction(notificationId: string, buttonIndex: number) {
  return put({
    url: `${API_BASE}/${notificationId}/button-clicked/${buttonIndex}`,
  })
}
